import React, { useState, useMemo } from "react";
import "./UrlGrid.css";

const UrlGrid = () => {
  const links = useMemo(
    () => [
      { id: 1, title: "European Society for Medical Oncology 2024 (ESMO)", url: "https://www.esmo.org/meeting-calendar/esmo-congress-2024" },
      { id: 4, title: "European Society for Medical Oncology 2025 (ESMO)", url: "https://www.esmo.org/meeting-calendar/esmo-congress-2025" },
      { id: 2, title: "IDWeek 2024", url: "https://idweek.org/" },
      { id: 5, title: "IDWeek 2025", url: "https://idweek.org/" },
      { id: 3, title: "American Society of Hematology 2024 (ASH)", url: "https://www.hematology.org/meetings/annual-meeting" },
      { id: 6, title: "American Society of Hematology 2025 (ASH)", url: "https://www.hematology.org/meetings/annual-meeting" },
    ],
    []
  );

  const [selected, setSelected] = useState(null); // only one active ID

  const handleSelect = (id) => {
    setSelected((prev) => (prev === id ? null : id)); // toggle if same, else switch
  };

  return (
    <div className="url-container">
      {links.map((link) => {
        const isSelected = selected === link.id;
        return (
          <div
            key={link.id}
            className={`url-strip ${isSelected ? "selected" : ""}`}
            onClick={() => handleSelect(link.id)}
            title={link.url}
          >
            <div className="url-title">{link.title}</div>
          </div>
        );
      })}
    </div>
  );
};

export default UrlGrid;